import { ChangeDetectionStrategy, Component } from '@angular/core';
import { BaseTypographyComponent } from '../base-typography.component';
import { CommonModule } from '@angular/common';
@Component({
  selector: 'app-body-lg',
  template: '<span [ngClass]="ngClass"><ng-content></ng-content></span>',
  styleUrls: ['./body-large.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule
  ]
})
export class BodyLargeComponent extends BaseTypographyComponent {}
